import SignupBg from "../../assets/images/study-signup.svg";
import Blocks from "../blocks";

const PageStudentUpcomingClass = () => {
    return (
        <div className={'page PageStudentUpcomingClass'}>
            <div className="container mx-auto">
                <h1 className={"text-center md:hidden text-xl md:text-6xl  pt-16 font-['Poppins-Bold']"}>Hi, John</h1>
                <h4 className={'text-center md:hidden text-md md:text-xl font-normal mb-10 md:mb-16'}>{'Welcome!'}</h4>
                <div className="flex flex-col md:flex-row items-center">
                    <div className="bgWrapper md:flex justify-center items-center bg-white">
                        <img src={SignupBg} alt=""/>
                    </div>
                    <div
                        className="pageContent w-full max-w-2xl mx-auto md:mr-0 md:ml-auto mt-4 md:mt-0  mb-4 bg-white p-4 rounded-xl">
                        <h1 className={"hidden text-center md:text-left md:text-6xl md:block font-['Poppins-Bold']"}>Hi,
                            John</h1> ToDo:
                        <h4 className={'hidden text-center md:text-left text-lg md:text-xl md:block text-2xl font-normal mb-10 md:mb-16'}>{'Welcome!'}</h4>
                        <Blocks.ErrorBoundary>
                            <div className={"rounded-lg shadow p-4"}>
                                <div
                                    className="flex item-center flex-col gap-3 md:gap-0 md:flex-row divide-y-2 md:divide-y-0 md:divide-x-2">
                                    <ul className={"flex-1 p-2"}>
                                        <li className="flex items-center  mb-4">
                                            <span className="icon icon-user text-zinc-400 text-2xl pr-5"></span>
                                            <p className={"text-100 text-md"}>Teacher - Miss Jyoti</p>
                                        </li>
                                        <li className="flex items-center  mb-4">
                                            <span className="icon icon-book-open text-zinc-400 text-2xl pr-5"></span>
                                            <p className={"text-100 text-md"}>Subject - Science</p>
                                        </li>
                                        <li className="flex items-center  mb-4">
                                            <span className="icon icon-calendar text-zinc-400 text-2xl pr-5"></span>
                                            <p className={"text-100 text-md"}>Date - 12th Jan 2022</p>
                                        </li>
                                        <li className="flex items-center  mb-4">
                                            <span className="icon icon-clock text-zinc-400 text-2xl pr-5"></span>
                                            <p className={"text-100 text-md"}>Time - 9 AM - 10 AM</p>
                                        </li>
                                        <li className="flex items-center  mb-4">
                                            <span className="icon icon-users text-zinc-400 text-2xl pr-5"></span>
                                            <p className={"text-100 text-md"}>Attendees - 20</p>
                                        </li>

                                    </ul>
                                    <div className={"flex-1 py-2 px-6"}>
                                        <div className="flex items-center mt-2 md:mt-0">
                                            <span
                                                className="icon icon-unordered-list text-zinc-400 text-100 text-xl pr-4"></span>
                                            <h1 className={"justify-center items-center"}>Details</h1>
                                        </div>
                                        <p className={"mt-8 text-sm"}>Lorem ipsum dolor sit amet, consectetur adipiscing
                                            elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                                            enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
                                            aliquip ex ea commodo consequat. </p>
                                    </div>
                                </div>
                                <div className="flex justify-end mt-4 md:mt-0">
                                    <button className="bg-black w-full md:w-fit rounded-lg text-white px-4 py-2">
                                        Join
                                    </button>
                                </div>
                            </div>

                            <button
                                className="mt-8 w-full text-center flex items-center justify-center text-lg md:text-2xl">
                                <p>Go to my dashboard </p><span className="icon icon-arrow-right pl-2"></span>
                            </button>
                        </Blocks.ErrorBoundary>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PageStudentUpcomingClass;
